import React, { useCallback } from 'react';
import { Button, LinearProgress } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { ConfirmActionCallBackType, ConfirmationDialogProps } from './ConfirmationDialog.props';
import { Actions, Content, ContentSpaced } from './ConfirmationDialog.styles';
import { CONFIRMATION_DIALOG_TEST_IDS } from './ConfirmationDialog.testIds';
import Dialog from '../Dialog';

const ConfirmationDialog = ({
  open,
  title,
  maxWidth = 'sm',
  children,
  onClose,
  actions,
  isLoading,
}: ConfirmationDialogProps) => {
  const confirmAction = useCallback(
    async (callback?: ConfirmActionCallBackType) => {
      if (callback) {
        await callback();
      }
      onClose();
    },
    [onClose]
  );

  const ContentComponent = maxWidth !== 'xs' ? ContentSpaced : Content;

  return (
    <Dialog title={title ?? 'Confirmation'} maxWidth={maxWidth} fullWidth onClose={onClose} open={open}>
      {isLoading && <LinearProgress color="primary" />}
      <ContentComponent>{children}</ContentComponent>
      <Actions>
        {actions?.map(action => {
          let sx = {};
          if (action.type === 'success') {
            sx = {
              color: (theme: Theme) => theme.palette.error.contrastText,
              backgroundColor: (theme: Theme) => theme.palette.secondary.main,
              '&:hover': {
                backgroundColor: (theme: Theme) => theme.palette.secondary.dark,
              },
            };
          } else if (action.type === 'danger') {
            sx = {
              color: (theme: Theme) => theme.palette.error.contrastText,
              backgroundColor: (theme: Theme) => theme.palette.error.light,
              '&:hover': {
                backgroundColor: (theme: Theme) => theme.palette.error.dark,
              },
            };
          }
          return (
            <Button
              key={action.label}
              data-testid={CONFIRMATION_DIALOG_TEST_IDS.action(action.label)}
              variant={action.variant}
              disabled={action.disabled}
              color="primary"
              sx={sx}
              onClick={() => (action.callback ? confirmAction(action.callback) : onClose())}>
              <span>{action.label}</span>
            </Button>
          );
        })}
      </Actions>
    </Dialog>
  );
};

export default ConfirmationDialog;
